// extracted by mini-css-extract-plugin
module.exports = {"emptyState":"_2cUMF","primaryText":"jewhm","secondaryText":"_3rxnx"};